module.exports = __webpack_public_path__ + "media/images/comunicado_pix-5291ac0c5403a8c97a162a2f621ac8f2.jpeg";